
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 11v1c0 2.77-.664 5.445-1.915 7.846l-.227.42-1.747-.974c1.16-2.08 1.81-4.41 1.882-6.836L13 12v-1h2zM9 8h2v4l-.005.379a12.941 12.941 0 01-2.691 7.549l-.231.29-1.55-1.264a10.944 10.944 0 002.47-6.588L9 12V8zm1-4a5 5 0 015 5h-2a3 3 0 10-6 0v3c0 2.235-.82 4.344-2.271 5.977l-.212.23-1.448-1.38a6.969 6.969 0 001.925-4.524L5 12V9a5 5 0 015-5zm0-4a9 9 0 019 9v3c0 1.698-.202 3.37-.597 4.99l-.14.539-1.93-.526c.393-1.437.614-2.922.659-4.435L17 12V9A7 7 0 005.808 3.394L4.383 1.968A8.962 8.962 0 0110 0zM2.968 3.383l1.426 1.425a6.966 6.966 0 00-1.39 3.951L3 9l.004 2c0 1.12-.264 2.203-.762 3.177l-.156.29-1.737-.992a4.95 4.95 0 00.646-2.183L1.004 11V9a8.94 8.94 0 011.964-5.617z","fill":"#FAAD14"}})])
          )
        }
      }
    